const items = {
  "utilities.time.now": "现在",
  "utilities.time.secs_ago": "秒之前",
  "utilities.time.mins_ago": "分钟之前",
  "utilities.time.hs_ago": "小时之前",
  "utilities.time.days_ago": "天之前",
  "utilities.time.weeks_ago": "周之前",
  "utilities.time.months_ago": "月之前",
  "utilities.time.year_ago": "年之前",
  "utilities.time.years_ago": "年之前",
};

export default items;
